import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import {
    Typography,
    Card,
} from '@mui/material';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import TableHead from '@mui/material/TableHead';
import Tooltip from '@mui/material/Tooltip';

export const ContentContainer = styled('div')({
    position: 'relative',
    minHeight: 'calc(100vh - 64px)',
    paddingBottom: '100px',
    overflowY: 'auto',
    marginLeft: 70,
});

export const MainContent = styled('div')({
    padding: '20px',
    marginBottom: '20px',
    marginTop: '50px',
});

export const CenteredCard = styled(Card)({
    maxWidth: '100%',
    margin: '20px',
    marginTop: '80px',
    borderBottom: '2px solid dodgerblue',
    //borderRight: '2px solid dodgerblue',
    marginBottom: '10px',
});

// Styled Table Container
export const StyledTableContainer = styled(Paper)({
    padding: '16px',
    maxWidth: '100%',
    margin: '16px 0',
    overflowX: 'auto',
    boxShadow: 'none',
    borderRadius: '4px',
    backgroundColor: '#FFFFFF',
    border: 'none',
});

// Styled Table Head
export const StyledTableHead = styled(TableHead)({
    backgroundColor: '#333',
    color: '#ffffff',
    fontWeight: 'bold',
    borderRadius: '8px 8px 0 0',
    textAlign: 'center',
    '& th': {
        borderBottom: 'none',
    },
});

export const HeaderTitle = styled(Typography)({
    flexGrow: 1,
    fontSize: '1.4rem',
    color: '#333',
    fontWeight: 'normal',
    textAlign: 'left',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
});

// Styled Table Column
export const StyledTableColumn = styled(TableCell)({
    fontWeight: 'bold',
    fontSize: '1rem',
    textAlign: 'center',
    padding: '12px 16px',
    backgroundColor: '#f0f0f0',
    borderRight: '1px solid #cccccc',
    color: '#333',
    borderRadius: '0',
    '&:last-child': {
        borderRight: 'none',
    },
    '&:hover': {
        backgroundColor: '#d6d6d6',
        transition: 'background-color 0.2s ease',
    },
});

// Styled Table Cell
export const StyledTableCell = styled(TableCell)({
    fontSize: '0.965rem',
    textAlign: 'center',
    padding: '12px 16px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #cccccc',
    color: '#333',
    borderRadius: '0',
    '&:hover': {
        backgroundColor: '#f5f5f5',
        transition: 'background-color 0.2s ease',
    },
});

export const StyledChartCard = styled(Card)(({ theme }) => ({
    maxWidth: '90%',
    margin: 'auto',
    marginTop: theme.spacing(-2), // Adds margin at the top
    marginBottom: theme.spacing(3), // Adds margin at the bottom
    borderRadius: '8px',
    boxShadow: theme.shadows[5], // Adds a subtle shadow
    backgroundColor: theme.palette.background.paper,
    overflow: 'visible', // Allows content to overflow if needed
    padding: theme.spacing(2), // Adds padding inside the card
    transition: 'transform 0.3s ease-in-out', // Smooth transition effect
}));

export const RefreshIcon = styled('img')({
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
        transform: 'rotate(360deg)',
    },
});

export const CustomTextField = styled(TextField)({
    '& .MuiInput-root': {
        color: 'dodgerblue',
        fontSize: '1rem',
    },
    '& .MuiInput-underline:after': {
        borderBottomColor: 'dodgerblue',
    },
    '& .MuiInput-underline:before': {
        borderBottomColor: 'dodgerblue',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
        borderBottomColor: 'dodgerblue',
    },
});

export const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .MuiTooltip-tooltip`]: {
        backgroundColor: '#333',
        color: '#fff',
        fontSize: '12px',
        padding: '5px 9px',
        borderRadius: '6px',
        border: '2px solid #39B3D7',
        boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    },
    [`& .MuiTooltip-arrow`]: {
        color: '#39B3D7',
    },
});